export default {"src":"/_next/static/media/kerala.0dfe6068.svg","height":336,"width":384,"blurWidth":0,"blurHeight":0};